import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { http } from "../../helpers/http";
import { useSelector } from "react-redux";
import Auth from "../../auth/Auth";

function ProfileWishlistCart() {
  const { pathname } = useLocation()
  const cartItems = useSelector((state) => state.cart.cartItems);
  const isCountUpdated = useSelector((state) => state.general.isCountUpdated);
  const navigate = useNavigate();
  const [countData, setCountData] = useState('');

  const getCount = () => {
    http(
      {
        method: "POST",
        url: `cartCount`,
        isSecure: true,
        body: { udId: Auth.userInfo()?.udId }
      },
      (res) => {

        setCountData(res);
      },
      (res) => { }
    );
  };
  useEffect(() => {
    getCount();
  }, [isCountUpdated, cartItems]);

  return (
    <div className="d-flex profile-wishlist-cart">
      {Auth.isUserAuthenticated() && <span className={`m-auto profileIcon-center ${pathname.includes("restro-menu") && "customProfile"}`}>

        <NavLink to={pathname.includes("restro-menu") ? `/restro-menu/profile` : "/profile"}>
          <img className="pointer" src="./assets/img/head_profile.svg" alt="" />
        </NavLink>
      </span>}

      {
        !pathname.includes("restro-menu") && !pathname.includes("restro-menu/profile") &&
        <>
          <span className="me-2">
            <div className="notification-view">
              {!!countData.FavouriteCount && (
                <div className="notitxt">{countData.FavouriteCount}</div>
              )}
              {/* <NavLink to="/favorites">
            <img
              className="pointer"
              src="./assets/img/head_like.svg"
              alt=""
              onClick={() => navigate("favorites")}
            />
          </NavLink> */}
            </div>
          </span>
          <span>
            <div className="notification-view">
              {countData > 0 && (
                <div className="notitxt">{countData}</div>
              )}
              <NavLink to="/my-cart">
                <img
                  className="pointer"
                  src="./assets/img/head_cart.svg"
                  onClick={() => navigate("my-cart")}
                  alt=""
                />
              </NavLink>
            </div>
          </span>
        </>
      }
    </div >
  );
}

export default ProfileWishlistCart;
